import { extendTheme } from "@chakra-ui/react";
import { commonStyles } from "./common";

export const colors = {
  brand: {
    primary: "#7630EC",
    background: "#F0F1F5",
    primaryLight: "#F7F1FF",
    primaryText: "#7630EC",
    backgroundLight: "#ffffff",
    textBg: "#F0F1F5",
    textColor: "#000000",
    textLight: "#ffffff",
    textInactive: "#5E5F64",
    separator: "#A9A9A9",
    errorColor: "#FF002E",
    toolTipBg: "#606062",
    toolTipText: "#ffffff",
    warning: "#ECC94B",
    textSec: "#8C8C8C",
    success: "#F0FFF4",
  },
};

export const styles = {
  global: () => ({
    body: {
      bg: "brand.background",
      fontFamily: "regular",
      color: "brand.textColor",
    },
  }),
};

const theme = extendTheme({
  colors,
  styles,
  ...commonStyles,
});

export default theme;
